import React, { useState } from 'react';
import { Button } from './ui/button';
import { Heart } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

// Reusable like/save control used across verticals (flights, hotels, experiences, …).
// Logged-out users get the sign-in popup; the save completes automatically after auth.
export const SaveButton = ({ itemType, title, data, initialSaved = false, className = '', testid = 'save-item-button' }) => {
  const { requireAuth } = useAuth();
  const [saved, setSaved] = useState(initialSaved);
  const [busy, setBusy] = useState(false);

  const toggle = (e) => {
    e?.stopPropagation?.();
    requireAuth(async () => {
      if (saved || busy) return;
      setBusy(true);
      try {
        await api.saveItem({ item_type: itemType, title, data });
        setSaved(true);
        toast.success('Saved to your account');
      } catch {
        toast.error('Could not save');
      } finally {
        setBusy(false);
      }
    });
  };

  return (
    <Button variant="outline" size="icon" onClick={toggle} aria-label={saved ? 'Saved' : 'Save'}
      className={`h-10 w-10 rounded-xl shrink-0 ${className}`} data-testid={testid}>
      <Heart className={`h-4 w-4 ${saved ? 'fill-accent text-accent' : ''}`} />
    </Button>
  );
};
